import SweetAlert from '@components/Feedback/SweetAlert/Index';
import PageWrapper from '@components/UI/PageWrapper/Index';
import { useAppAuth } from '@contexts/AuthContext';
import React, { useEffect } from 'react'

const Home = () => {
  const { nome, isAuthenticated, loading } = useAppAuth();

  useEffect(() => {
    if (!loading && isAuthenticated && !sessionStorage.getItem('welcomeToastShown')) {
      SweetAlert.toastSuccessWithSubtitle(
        `Olá, ${nome || 'usuário'}!`,
        'Sua sessão foi iniciada com sucesso.'
      );
      sessionStorage.setItem('welcomeToastShown', 'true');
    }
  }, [isAuthenticated, loading, nome]);

  return (
    <PageWrapper>
      <div className="row">
        <iframe
          title="Dashboard Home Sistema de Auditoria"
          width="1400"
          height="950"
          src="https://app.powerbi.com/reportEmbed?reportId=d3400aba-29b5-42eb-866c-9b8895124293&autoAuth=true&ctid=e6c6824e-919b-4fbd-8d4d-1a79f1c2f8d2"
        >
        </iframe>

      </div>
    </PageWrapper>
  )
}

export default Home;